module.exports = __webpack_public_path__ + "img/supportwildlifewebp.a4724c7d.webp";